module.exports = __webpack_public_path__ + "img/INTERIOR-BALENO-6.0d6278c5.jpg";